import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Search, Filter, RotateCcw } from 'lucide-react';

interface SimpleCostCenterFiltersProps {
  onFiltersChange: (filters: {
    search: string;
  }) => void;
  className?: string;
}

export function SimpleCostCenterFilters({ onFiltersChange, className }: SimpleCostCenterFiltersProps) {
  const [search, setSearch] = useState('');

  const handleSearchChange = (value: string) => {
    setSearch(value);
    onFiltersChange({ search: value });
  };

  const handleReset = () => {
    setSearch('');
    onFiltersChange({ search: '' });
  };

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Filter className="h-5 w-5" />
          Filtros
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Campo de busca */}
        <div className="space-y-2">
          <label className="text-sm font-medium">Buscar</label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
            <Input
              placeholder="Buscar..."
              value={search}
              onChange={(e) => handleSearchChange(e.target.value)}
              className="pl-10"
            />
          </div>
        </div>

        {/* Botão de reset */}
        <div className="flex justify-end">
          <Button
            variant="outline"
            size="sm"
            onClick={handleReset}
            className="flex items-center gap-2"
          >
            <RotateCcw className="h-4 w-4" />
            Limpar
          </Button>
        </div>

        {/* Informações adicionais */}
        {search && (
          <div className="text-sm text-muted-foreground border-t pt-4">
            <p>Filtrando por: <span className="font-medium">{search}</span></p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

// Hook para gerenciar filtros (pode ser expandido no futuro)
export function useSimpleCostCenterFilters(costCenters: any[]) {
  const [filters, setFilters] = useState({
    search: '',
  });

  const filteredCostCenters = costCenters.filter(costCenter => {
    if (!filters.search) return true;

    const searchLower = filters.search.toLowerCase();
    return (
      costCenter.name.toLowerCase().includes(searchLower) ||
      (costCenter.description && costCenter.description.toLowerCase().includes(searchLower))
    );
  });

  return {
    filters,
    setFilters,
    filteredCostCenters,
    hasActiveFilters: !!filters.search,
  };
}